export default __webpack_public_path__ + "static/media/23.61879009.jpg";